module.exports = __webpack_public_path__ + "img/59.f2a6edc9.jpg";